const formValid = async (nomProduit, categoryProduit, descriptionProduit, sousCategoryProduit, prixProduit, image) => {
    return !(nomProduit === "" || categoryProduit === "" || descriptionProduit === "" || sousCategoryProduit === "" || image === null || prixProduit === "");
}

export default formValid;